import { forwardRef } from 'react';
import type { SvgIconProps } from '@mui/material';
import { SvgIcon } from '@mui/material';

export const SwitchIcon = forwardRef<SVGSVGElement, SvgIconProps>(({ sx, ...props }, ref) => (
  <SvgIcon viewBox="0 0 24 24" sx={{ fill: 'none', ...sx }} {...props} ref={ref}>
    <path
      d="M13 19H10C7.239 19 5 16.761 5 14V5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 5H14C16.761 5 19 7.239 19 10V19"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 7.5L5 5L2.5 7.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16 16L19 19L22 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
));
